import Footer from "./Footer";
import { useTranslation } from 'react-i18next';
import {
    FooterContent
} from '@sentara-health/optimahealth_web';

export const FooterNav = () => {
    return (
        <Footer />
    )
}

export const FooterDisclaimer = () => {
    const { t } = useTranslation();
    return (
        <FooterContent
            copyrightText={t('common.optimaCopyrightText1', { year: new Date().getFullYear() })}
            footerDescription={t('common.footerText')}
        />
    )
}
